import React from "react";
import { Area } from "@ant-design/charts";
import { StyledFormSection } from "../predictions";
import EstimatedAmount from "./EstimatedAmount";
import styled from "styled-components";
import { GoalStats } from "src/store/Goal-Based/goal";
import { SliderTitleProps } from "./SliderTitle";
import moment from "moment";
import { theme } from "src/theme/theme";

const StyledChart = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
const customFormatter = Intl.NumberFormat("en", { notation: "compact" })
  .format as any;

export function AmountPredictionChart(props: {
  data: GoalStats | undefined;
  isLoading: boolean;
  titles: SliderTitleProps;
}) {
  const { data, isLoading, titles } = props;
  const transformedData = data?.data?.flatMap((item) => [
    {
      index: item.index,
      estimationType: "optimistic",
      value: item["Optimistic scenario"],
    },
    {
      index: item.index,
      estimationType: "targeted",
      value: item["investment"],
    },
    {
      index: item.index,
      estimationType: "pessimistic",
      value: item["Pessimistic scenario"],
    },
  ]);

  const config = {
    data: transformedData ?? [],
    height: 170,
    xField: "index",
    yField: "value",
    yAxis: {
      label: {
        autoHide: true,
        formatter: customFormatter,
      },
    },
    tooltip: {
      formatter: (item) => {
        return { name: item.estimationType, value: Math.round(item.value) };
      },
    },
    seriesField: "estimationType",
    color: ["#4CAF50", "#8BC34A", "#CDDC39"],
    areaStyle: {
      fillOpacity: 0.6,
    },
    loading: isLoading,
  };

  function differenceInYearsAndMonths(date1, date2) {
    const start = new Date(date1);
    const end = new Date(date2);

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    // Adjust for negative months
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return { years, months };
  }

  function getAmount(title: string) {
    if (!data || data?.length === 0) return 0;

    if (title === "Goal Contribution")
      return data ? Math.round(data?.contribution_amount) : 0;
    if (title === "Final / Goal Amount")
      return data ? Math.round(data?.goal_amount) : 0;
    if (title === "Investment Initial Amount")
      return data ? Math.round(data?.initial_amount) : 0;
    else {
      return differenceInYearsAndMonths(data?.start_date, data?.end_date);
    }
  }
  return (
    <StyledChart>
      <StyledFormSection color={"rgba(18, 183, 106, 0.25)"}>
        <EstimatedAmount amount={getAmount(titles.title)} titles={titles} />
      </StyledFormSection>
      <StyledFormSection color={"rgba(18, 183, 106, 0.25)"}>
        <Area {...config} />
      </StyledFormSection>
    </StyledChart>
  );
}
export default AmountPredictionChart;
